import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import { toToman } from "../../utils/Utils";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function Last30DaysInvestment({ sx = [], ...props }) {
  const { lastInvestment = { autoAmount: 0, manualAmount: 0 } } = props;
  const [open, setOpen] = useState(false);
  return (
    <Box
      onClick={() => {
        setOpen((prev) => !prev);
      }}
      sx={{
        width: "100%",
        p: "16px",
        borderRadius: "12px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        {open ? (
          <KeyboardArrowUpIcon sx={{ color: "primary.main", height: 20 }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ color: "primary.main", height: 20 }} />
        )}
      </Box>
      <Typography align="center" variant="h6" color="grey.2">
        سرمایه‌گذاری شما در ۳۰ روز گذشته
      </Typography>
      <Typography
        mt={"8px"}
        align="center"
        variant="h3"
        color="primary.main"
        component={"div"}
      >
        {`${toToman(
          lastInvestment?.autoAmount || 0 + lastInvestment?.manualAmount || 0
        )}`}
        <Box display={"inline"} typography={"subtitle1"}>
          {" "}
          تومان
        </Box>
      </Typography>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box
          sx={{
            mt: "8px",
            borderTop: (theme) => `1px solid ${theme.palette.grey[6]}`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              mt: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1" color="grey.3">
              سرمایه گذاری خودکار
              <Box display={"inline"} fontSize={10}>
                {" "}
                (تومان)
              </Box>
            </Typography>
            <Typography variant="body2" color="grey.2">
              {toToman(lastInvestment?.autoAmount || 0)}
            </Typography>
          </Box>
          <Box
            sx={{
              mt: "12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1" color="grey.3">
              سرمایه گذاری مستقیم
              <Box display={"inline"} fontSize={10}>
                {" "}
                (تومان)
              </Box>
            </Typography>
            <Typography variant="body2" color="grey.2">
              {toToman(lastInvestment?.manualAmount || 0)}
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

export default Last30DaysInvestment;
